import React, { useState } from 'react';
import '../assets/css/header.css';
import GoogleLogin from './GoogleLogin';
import Logo from '../assets/media/dk.png'
import { NavLink, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [menu , setMenu] = useState(false);
  const menuShow = () => {
    setMenu(true);
  }


  return (
    <header className='header-sec'>
      <div>
        <NavLink to="/" end> <h4>Dk</h4></NavLink>
       
      </div>
      {/* Left Section */}
      <div className="header-left">
        <ul className="nav-list">
          <li>
            <NavLink to="/" end >Home</NavLink>
          </li>
          <li>
            <NavLink to="/portfolio" >Portfolio</NavLink>
          </li>
          <li>
            <NavLink to="/about"  > About</NavLink>
          </li>
          <li>
            <NavLink to="/service"  >Service</NavLink>
          </li>
          <li>
            <NavLink to="/contact" >Contact Us</NavLink>
          </li>
          {/* <li>
            <GoogleLogin />
          </li> */}
        </ul>
      </div>

      {/* Right Section */}
      <div className="header-btn" onClick={menuShow}>
        <i className="fa-regular fa-bars"></i>
     
      </div>
      
      {
        menu ? 
        <div className='mob-menu'> 
                <ul className="">
                  <li>
                    <div className='mob-head'>
        <h4>Dk</h4>
        <i className='fa-regular fa-xmark' onClick={() => setMenu(false)} ></i>
      </div>
          </li>
          <li>
            <NavLink to="/" end onClick={()=> setMenu(false)}>Home</NavLink>
          </li>
          <li>
            <NavLink to="/portfolio" onClick={()=> setMenu(false)}>Portfolio</NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={()=> setMenu(false)}>About</NavLink>
          </li>
          <li>
            <NavLink to="/service" onClick={()=> setMenu(false)}>Service</NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={()=> setMenu(false)}>Contact Us</NavLink>
          </li>
          {/* <li>
            <GoogleLogin />
          </li> */}
        </ul>
        </div>
        : 
        ''
      }
    </header>
  );
}

export default Header;
